<template>
  <v-container id="webshop">
    <div class="web-shop-body">
      <div class="shop-banner">
        <h1 class="banner-header">
          {{ $t("label.select") }}: {{ selectedCategory.name }}
        </h1>
        <VSelect
          :items="webshopCategories"
          item-text="name"
          v-model="selectedCategory"
          varient="outlined"
          return-object
        />
      </div>
      <div class="shop-products">
        <ProductGrid
          :products="products"
          :loading="loading"
          :authenticated="true"
          @loadProducts="loadProducts"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
import ProductGrid from "./components/ProductGrid.vue";
export default {
  name: "Overview",
  components: {
    ProductGrid
  },
  mounted() {
    this.loadCategories();
    this.loadProducts();
  },
  data() {
    return {
      products: [],
      next_page_url: null,
      webshopCategories: [{ name: this.$t("label.all"), uuid: null }],
      selectedCategory: { name: this.$t("label.all"), uuid: null },
      allProductsLoaded: false,
      loading: false
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    selectedCategory: function() {
      this.allProductsLoaded = false;
      this.offset = 0;
      this.products = [];
      this.loadProducts();
    }
  },

  methods: {
    loadCategories() {
      this.$store.dispatch("product/getCategories").then(response => {
        response.data.forEach(new_category => {
          this.webshopCategories.push({
            name: new_category.name,
            uuid: new_category.uuid
          });
        });
      });
    },
    loadProducts() {
      if (this.allProductsLoaded || this.loading) {
        return;
      }
      this.loading = true;
      this.$store
        .dispatch("product/getProducts", {
          next_page_url: this.next_page_url,
          category: this.selectedCategory.uuid
        })
        .then(response => {
          this.products.push(...response.data);
          if (!response.headers.get("Next-Page-Url")) {
            this.allProductsLoaded = true;
            this.next_page_url = null;
          } else {
            this.next_page_url = response.headers.get("Next-Page-Url");
          }
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.web-shop-body {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 30px;
}

.shop-banner {
  padding: 20px;
  border-radius: 5px;
}

.shop-banner .v-select {
  cursor: pointer;
  width: 25rem;
}
</style>
